import React from 'react';
import { Route } from 'react-router-dom';
import { AsyncComponent } from '@twigeducation/async-component';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import AccessErrorPage from '../AccessErrorPage';
import Layout from '../../layout';
import withProductSubscriptions from '../../components/withProductSubscriptions';
import AsyncComponentError from '../../components/AsyncComponentError';

const Accounts = withProductSubscriptions(props => (
    <AsyncComponent
        appName="ts-accounts"
        authUrl={window.config.AUTHENTICATION_URL}
        componentName="Accounts"
        errorComponent={AsyncComponentError}
        unleash={{
            clientId: window.config.UNLEASH_CLIENT_ID,
            url: window.config.UNLEASH_URL,
        }}
        {...props}
    />
));

const allowedRoles = ['TEACHER', 'SCHOOL_ADMIN', 'DISTRICT_OWNER', 'TWIGADMIN'];

const routes = [
    <Route path="/accounts/*" key="accounts">
        <Accounts Layout={Layout} isMiddleSchool ssoClientId={window.config.SSO_CLIENT_ID} />
    </Route>,
    <Route path="/classes" key="classes">
        <WithAuthentication
            roles={allowedRoles}
            RoleErrorComponent={() => <AccessErrorPage link="/student-dashboard/" />}
        >
            <Accounts Layout={Layout} isMiddleSchool ssoClientId={window.config.SSO_CLIENT_ID} />
        </WithAuthentication>
    </Route>,
];

export default routes;
